var Filters = {
	init:function(){
		
		$(".shop-top-widget .filters-title").on("click touchend", function(e){
			if(e.type == 'touchend'){
				$(this).off("click");
			}
		
			if($(".shop-top-widget").hasClass("open")){
				Filters.close_filters();
			}else{
				Filters.open_filters();
			}
			
		})
	},
	open_filters:function(){
		$(".shop-top-widget").addClass("open");
		
		var _h = 0;
		
		$(".shop-top-widget .widget").each(function(){
			
			if($(this).outerHeight() > _h){
				_h = $(this).outerHeight();
			}
		});
		
		$(".shop-top-widget .filters-content").css({height:_h +20});
		
		
	},
	close_filters:function(){
		$(".shop-top-widget").removeClass("open");
		$(".shop-top-widget .filters-content").css({height:0});
	}

}

$(window).load(function(){
	if($(".shop-top-widget").length){
		Filters.init();
	}
});